import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import StyledDropDown from './styles/StyledDropDown';
import { isDropdownOutsideClickSuppressed } from './outsideClickGuard';

class DropDown extends Component {
  static propTypes = {
    parent: PropTypes.instanceOf(Element).isRequired,
    children: PropTypes.instanceOf(Object).isRequired,
    outsideClick: PropTypes.instanceOf(Function),
    show: PropTypes.bool.isRequired,
    unmountOnExit: PropTypes.bool,
  };

  static defaultProps = {
    unmountOnExit: false,
    outsideClick: () => {},
  };

  dropDownRef = React.createRef();

  componentWillMount() {
    // Bubble phase: target handlers (incl. autocomplete suppress) run first
    document.addEventListener('mousedown', this.handleOutsideClick, false);
    document.addEventListener('click', this.handleOutsideClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick, false);
    document.removeEventListener('click', this.handleOutsideClick, false);
  }

  isEventInside = e => {
    const { parent } = this.props;
    const root = this.dropDownRef.current;
    const path = typeof e.composedPath === 'function' ? e.composedPath() : [];

    if (root && (root.contains(e.target) || path.indexOf(root) !== -1)) {
      return true;
    }
    if (parent && (parent.contains(e.target) || path.indexOf(parent) !== -1)) {
      return true;
    }
    if (e.target && e.target.closest && e.target.closest('[data-address-autocomplete="true"]')) {
      return true;
    }

    return false;
  };

  handleOutsideClick = e => {
    const { outsideClick, show } = this.props;

    if (!show) {
      return;
    }

    if (isDropdownOutsideClickSuppressed()) {
      return;
    }

    if (this.isEventInside(e)) {
      return;
    }

    outsideClick();
  };

  render() {
    const { children, show, unmountOnExit } = this.props;
    this.click = show ? 0 : this.click;

    return (
      <div ref={this.dropDownRef}>
        <CSSTransition in={show} timeout={250} classNames="fade" unmountOnExit={unmountOnExit}>
          <StyledDropDown {...this.props}>{children}</StyledDropDown>
        </CSSTransition>
      </div>
    );
  }
}

export default DropDown;
